import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import i18n from '../../../../../constants/initLng';
import { useTranslation } from "react-i18next";
import * as CPN from "antd";
import Modal from '../../../common/component/Modal';
import * as Func from "../../../../../helpers/functions";
import { PATHS } from '../../../../../constants/Define';

export const EditComponent = (props) => {

    const { t } = useTranslation();
    const removeVoucher = () => {
        props.onDeleteVoucher({ id: props.item.id })
    }
    const onRemove = () => {
        const { confirm } = Modal;
        confirm({
            title: Func.formatValidation(t('validation.statusCode.code.7'), t(`item.voucher.title`)),
            okText: t(`action.remove`),
            cancelText: t(`action.cancel`),
            onOk: removeVoucher,
        });
    };
    return (
        <Fragment>
            {
                props.permisionActions && props.permisionActions.allowUpdate &&
                <Link to={Func.getPathWithParams(PATHS.VOUCHER.DETAIL.path, { id: props.item.id })} className={`mr-2 colorPrimary`}>
                    <CPN.Icon type="form" className="fs20" />
                </Link>
            }
        </Fragment>
    )
};
